import { render } from "./AdminConfigurationCreate.vue?vue&type=template&id=a55e0b02&scoped=true&ts=true&lang=true"
import script from "./AdminConfigurationCreate.vue?vue&type=script&lang=ts"
export * from "./AdminConfigurationCreate.vue?vue&type=script&lang=ts"

import "./AdminConfigurationCreate.vue?vue&type=style&index=0&id=a55e0b02&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a55e0b02"]])

export default __exports__